/**
 * Well context — the currently-selected well the top-bar switcher points at,
 * plus the active event (job) within that well. The record/report screens read
 * this to know which well and which event to load. Selecting a new well clears
 * the active event so it can't leak across wells.
 */
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface WellContextState {
  selectedWellId: string | null;
  /** Active event id; null means "let the screens pick a sensible default". */
  activeEventId: string | null;
}

const initialState: WellContextState = {
  selectedWellId: null,
  activeEventId: null,
};

const wellContextSlice = createSlice({
  name: "wellContext",
  initialState,
  reducers: {
    selectWell(state, action: PayloadAction<string | null>) {
      if (state.selectedWellId !== action.payload) {
        state.activeEventId = null;
      }
      state.selectedWellId = action.payload;
    },
    setActiveEvent(state, action: PayloadAction<string | null>) {
      state.activeEventId = action.payload;
    },
  },
});

export const { selectWell, setActiveEvent } = wellContextSlice.actions;
export const wellContextReducer = wellContextSlice.reducer;
